// src/data/reviewsData.js
export const reviews = [
  {
    name: "Carlos Jiménez",
    location: "Jalisco",
    title: "Buen material, fácil de trabajar",
    comment:
      "Pedí fibra 3K Twill 2x2 negra con resina OM1 y el resultado quedó perfecto. Se adhiere bien y tiene un brillo muy limpio.",
    product:
      "Fibra de carbono 3K Twill 2X2 Negro (10 m²) + Resina Epóxica Transparente OM1 (4 kg)",
    image: "/reviewsPictures/1.png",
  },
  {
    name: "Luis Hernández",
    location: "Nuevo León",
    title: "Llegó rápido y bien empacado",
    comment:
      "Primera compra, todo llegó bien, sin daños. La fibra venía enrollada y protegida. Se nota que cuidan los envíos.",
    product: "Fibra de carbono 12K Twill (rollo 50 m²)",
    image: "/reviewsPictures/2.jpg",
  },
  {
    name: "Ricardo López",
    location: "Ciudad de México",
    title: "El color azul se ve increíble",
    comment:
      "Usé la fibra azul metálica con resina UV y el acabado quedó genial. Bueno para interiores.",
    product:
      "Fibra de carbono 3K Twill 2X2 Azul Metálica (8 m²) + Resina Epóxica Transparente UV OMUV2 (4 kg)",
    image: "/reviewsPictures/3.png",
  },
  {
    name: "Daniel Torres",
    location: "Guanajuato",
    title: "Me encantó el tono dorado",
    comment:
      "La fibra dorada tiene un brillo metálico que resalta muchísimo. La combiné con flakes dorados y quedó de lujo.",
    product:
      "Fibra de carbono 3K Twill 2X2 Dorada Metálica (5 m²) + Flakes Dorado (2 botes)",
    image: "/reviewsPictures/4.png",
  },
  {
    name: "Eduardo Romero",
    location: "Querétaro",
    title: "Excelente trato y asesoría",
    comment:
      "Compré fibra honeycomb y resolvieron mis dudas sobre la resina normal y la UV. Muy atentos y puntuales con la entrega.",
    product:
      "Fibra de carbono 3K Honeycomb (6 m²) + Resina Epóxica Transparente OMUV2 (3 kg)",
    image: "/reviewsPictures/5.jpg",
  },
  {
    name: "Adrián Mendoza",
    location: "Puebla",
    title: "Se ve diferente a todo lo que había usado",
    comment:
      "La fibra camouflage está increíble, casi nadie la usa. La usé para un cofre y quedó brutal.",
    product: "Fibra de carbono 3K Camouflage Negro (5 m²)",
    image: "/reviewsPictures/6.png",
  },
  {
    name: "Iván Castillo",
    location: "Estado de México",
    title: "Material de primera y envío rápido",
    comment:
      "La fibra forjada diamante está genial, ya la estamos trabajando. Ya habíamos comprado antes y llegó en tiempo como siempre.",
    product: "Fibra de carbono 12K Forjada Diamante Negro (5 kg)",
    image: "/reviewsPictures/7.jpg",
  },
  {
    name: "Javier Ortega",
    location: "Baja California",
    title: "Buen precio por mayoreo",
    comment:
      "Pedimos varios metros de fibras metálicas desde su plataforma. Muy buena calidad y a buen precio.",
    product:
      "Fibra de carbono 3K Twill 2X2 Verde Metálica (10 m²) y otras fibras metálicas.",
    image: "/reviewsPictures/8.jpg",
  },
  {
    name: "Miguel Pérez",
    location: "Coahuila",
    title: "Perfecta para piezas personalizadas",
    comment:
      "Usamos la fibra forjada con resina OM1 y flakes verdes. Quedó muy bien.",
    product:
      "Fibra de carbono 12K Forjada (4 kg) + Resina Epóxica Transparente OM1 (3 kg) + Flakes Verde (1 bote)",
    image: "/reviewsPictures/9.png",
  },
  {
    name: "Alejandro Vargas",
    location: "Veracruz",
    title: "Cura parejo y deja un brillo limpio",
    comment:
      "La OM1 me funcionó perfecto para unas piezas con fibra que estoy haciendo. Fácil de mezclar y sin burbujas.",
    product: "Resina Epóxica Transparente OM1 (19 kg) + Catalizador CF1",
    image: "/reviewsPictures/10.jpg",
  },
  {
    name: "Fernando Ruiz",
    location: "Yucatán",
    title: "Excelente resistencia al sol",
    comment:
      "Probé la resina UV OMUV2 en unas piezas exteriores. Buen producto.",
    product: "Resina Epóxica Transparente UV OMUV2 (8 kg)",
    image: "/reviewsPictures/11.jpg",
  },
  {
    name: "Marco Ramírez",
    location: "Aguascalientes",
    title: "Acabado negro profundo, justo lo que buscaba",
    comment:
      "Pedimos todos los colores de flakes y tienen muy buena cantidad para distintos proyectos.",
    product:
      "Resina Epóxica Negra RN1 (4 kg) + Flakes varios colores (7 botes)",
    image: "/reviewsPictures/12.png",
  },
];
